import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import MapState , { ILocation } from './states'
import _ from 'lodash'
import store, { State } from '@/store/store'
import { hashFunction } from '@/services/Helpers'
import httpServiceWithToken from '@/services/HttpRequestServiceWithToken'
import httpService from '@/services/HttpRequestService'

export interface IRegisterStatus {
  registerStatus: boolean,
  code: number,
  message: string
}

const actions: ActionTree<MapState, State> = {
}

export default actions
